import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTooltip } from '@angular/material/tooltip';
import { Store } from '@ngrx/store';
import { AppModesEnum } from 'src/app/models/WebServer/appModesEnum';
import { PartecipantStatus } from 'src/app/models/WebServer/partecipantStatus';
// import { MultimediaMachineStatus } from 'src/app/models/multimediaMachineState';
import { PhoneStatusEnum } from 'src/app/models/phoneStatus';

import { AppHelper } from 'src/app/helpers/app.helper';
import { initialSessionConfig } from 'src/app/models/WebServer/sessionConfig';
import { AppConfigService } from 'src/app/services/app.config.service';
import { SettingsDialogService } from 'src/app/services/settings-dialog.service';
import { SipService } from 'src/app/services/sip.service';
import * as appActions from "src/app/store/actions/app.actions";
import { AppState } from 'src/app/store/states/app.state';
import { SvgConstants } from 'src/app/svgConstants';


@Component({
  selector: 'app-multimedia-buttons',
  templateUrl: './multimedia-buttons.component.html',
  styleUrls: ['./multimedia-buttons.component.scss']
})
export class MultimediaButtonsComponent implements OnInit {
  @Input() AS!: AppState;
  @Input() SECONDARYSTATUS?: PartecipantStatus;
  @Input() MYSTATUS!: PartecipantStatus;
  // @Input() selectorPlaceHolder: Map<string, string>;
  @Output() changeModeEvent: EventEmitter<AppModesEnum> = new EventEmitter<AppModesEnum>();
  @Output() showSessionInfo = new EventEmitter<boolean>;
  @Output() showCitizenInfo = new EventEmitter<boolean>;
  
  appModes = AppModesEnum;
  // multimediaStates = MultimediaNodeEnum;
  // machineState = MultimediaMachineStatus;
  phoneStatuses = PhoneStatusEnum;
  svgConstants = SvgConstants;

  constructor(
    private store: Store<AppState>,
    public config: AppConfigService,
    public dialog: MatDialog,
    // public sanitizer: SafeHtmlPipe,
    private sipService: SipService,
    private settingsDialogService: SettingsDialogService
    // private snackBar: MatSnackBar
  ) { }

  // minGuestWidth: number = 700; 
  // actualWidth: number = 700;
  ngOnInit(): void {
    // if(this.AS.isGuest) {
    //   this.minGuestWidth = parseInt(getComputedStyle(document.documentElement)
    //         .getPropertyValue('--media-max-width').replace('px', '')); // 710px

    //   window.onresize = () => this.actualWidth = window.innerWidth;
    // }
  }

  changeMode(mode: AppModesEnum, tip: MatTooltip | undefined) {
    this.closeTootilpOnClick(tip);
    setTimeout( () => { this.changeModeEvent.emit(mode)}, 100);
  }
  private closeTootilpOnClick(tip: MatTooltip | undefined) {
    if(tip) {
      // console.log('tooltip close')
      tip.hide();
    }

  }

  toggleLocalStream(tip: MatTooltip) {
    this.closeTootilpOnClick(tip) 
    // this.changeMode(AppModesEnum.Video);
    setTimeout( () => { this.store.dispatch(appActions.toggleVideo({}))}, 100);;
  }

  exit(tip: MatTooltip) {
    this.closeTootilpOnClick(tip);
    // Torna allo stato iniziale (landing o mappa a seconda della presenza di operatori)
    const anyOpOnline = this.config.operatorsStatus.length > 0;
    const sessionConfig = this.config.sessionConfig || initialSessionConfig;
    
    const modes = AppHelper.getHome(sessionConfig, this.MYSTATUS.partecipantRole, anyOpOnline);
    console.log(`[APPMODES] exit/goHome → anyOpOnline: ${anyOpOnline}, modes: [${modes}]`);
    setTimeout(() => { this.store.dispatch(appActions.setAppModes({ modes })); }, 100);
  }

  toggleMic(tip: MatTooltip) {
    this.closeTootilpOnClick(tip)
    setTimeout( () => { this.store.dispatch(appActions.toggleMicrophone({}))}, 100);

    // if (this.config.isCaller && this.config.phoneStatus != this.phoneStatuses.TALKING) {
    //   this.config.microphoneOn = !this.config.microphoneOn;
    //   this.sipService.sendInvite(this.config.targetPartecipantId, this.config.sendVideoOn, this.config.microphoneOn);
    //   return;
    // }
    // if (this.config.microphoneOn) {
    //   if (this.sipService.toggleMicrophone(false)) {
    //     this.config.microphoneOn = false;
    //     AppHelper.openSnackBar(this.snackBar, `${this.selectorPlaceHolder.get('SNACKBAR.MUTEMICROPHONE')} ${AppHelper.getIcon('microphone')}`, 'OK', this.config.agencySettings.SnackbarDefaultTimer);
    //   }
    // } else {
    //   if (this.sipService.toggleMicrophone(true)) {
    //     this.config.microphoneOn = true;
    //     AppHelper.openSnackBar(this.snackBar, `${this.selectorPlaceHolder.get('SNACKBAR.ENABLEMICROPHONE')} ${AppHelper.getIcon('microphone')}`, 'OK', this.config.agencySettings.SnackbarDefaultTimer);
    //   }
    // }
    // this.sipService.saveInvitationBusinessEvent('accepted', this.config.microphoneOn, this.config.sendVideoOn, BusinessEventTypes.SIPReinvite);
  }

  openDeviceSettings() {
    // Usa il servizio per aprire le impostazioni
    this.settingsDialogService.openSettings();
  }

  showGuestSessionInfo(show: boolean) {
    this.showSessionInfo.emit(true);
  }
  showGuestCitizenInfo(show: boolean) {
    this.showCitizenInfo.emit(true);
  }

  clickCount=0;
  lastClick=0;
  openDebug(){
    const now = Date.now();
    if ((now - this.lastClick) > 2000) {
      this.lastClick = now;
      this.clickCount = 0;
    } else {
      this.clickCount++;
      if (this.clickCount > 7){
        this.clickCount = 0;
        this.sipService.showCurrentSessions();
      }
    }
  }
  
}
